import { type CouponSectionCreate } from '../../../types'

export const createCouponData = (): CouponSectionCreate => ({
  data: null,
  type: 'coupon',
})
